/* eslint-disable import/prefer-default-export */
/* eslint-disable no-use-before-define */
import { getChecksum } from './cryptoUtils';
import isNullCheck from './global/isNullCheck';
import { getCommonHeaders as getHeaders } from '../components/userProfile/utils/webViewUtils';
/**
 * @param {String} body
 * @return {object}
 */
export function getCommonHeaders(body) {
  const headers = getAndroidHeaders();
  if (isNullCheck(body) && headers) {
    headers['X-MW-CHECKSUM'] = getChecksum(body);
  }
  console.log(headers);
  return headers;
}

/**
 * @param {String} body
 * @return {object}
 */
function getAndroidHeaders() {
  const headers = getHeaders();
  console.log('Headers from android ==>', headers);
  let parsedHeaders = null;
  if (headers) {
    parsedHeaders = JSON.parse(headers);
  }
  return parsedHeaders;
}
